import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-team-ui',
  templateUrl: './team-ui.component.html',
  styleUrls: ['./team-ui.component.css']
})
export class TeamUiComponent implements OnInit {
  @Input() teams: any;
  @Input() pageName: string;
  @Output() selectTeam: EventEmitter<any> = new EventEmitter();
  imgProduct = environment.URL_PRODUCT_IMAGES;

  constructor() { }

  ngOnInit() {
  }

  selectSport(team) {
    this.selectTeam.emit(team);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/team-ui/team-ui.component.ts